<template>
  <div>
    <v-text-field
      :value="value.title"
      label="Title"
      outlined
      dense
      @input="update('title', $event)"
    />
    <v-textarea
      :value="value.text"
      label="Body Text"
      outlined
      dense
      rows="3"
      @input="update('text', $event)"
    />
    <ImageUploader
      :value="value.image"
      label="Image URL"
      @input="update('image', $event)"
    />
    <v-text-field
      :value="value.ctaText"
      label="Button Text"
      outlined
      dense
      @input="update('ctaText', $event)"
    />
  </div>
</template>

<script>
import ImageUploader from "./ImageUploader.vue";

export default {
  components: { ImageUploader },
  props: {
    value: { type: Object, default: () => ({}) },
  },
  methods: {
    update(key, val) {
      this.$emit("input", { ...this.value, [key]: val });
    },
  },
};
</script>
